var mentions_default = {
  "mention": "_2eXtw",
  "mentionViewer": "R076-",
  "cursorDefault": "wI-oh",
  "cursorPointer": "YLDXh"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
